import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6eaa3658")

_pushScopeId("data-v-6eaa3658")
const _hoisted_1 = { class: "\n          page-heading-logo\n          font-weight-bold\n          position-absolute\n          mt-4 mt-md-0\n          py-3\n        " }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PageHeader = _resolveComponent("PageHeader")

  return (_openBlock(), _createBlock(_component_PageHeader, {
    title: _ctx.project.name
  }, {
    tagline: _withId(() => [
      _createTextVNode(_toDisplayString(_ctx.project.summary), 1)
    ]),
    logo: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("img", {
          class: "client-logo white",
          src: `/images/logos/${_ctx.project.thumbnailLogo}`
        }, null, 8, ["src"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})